import React from 'react';
import { Gift, CheckCircle } from 'lucide-react';
import BentoWidgetCard, { WidgetQuestion } from '../BentoWidgetCard';
import { getRewardsPerformanceData } from '../../../../utils/aiBriefingsData';
interface MarketplacePulseWidgetProps {
  onHide?: () => void;
  onAsk?: (question: string) => void;
}
const MarketplacePulseWidget: React.FC<MarketplacePulseWidgetProps> = ({
  onHide,
  onAsk
}) => {
  const data = getRewardsPerformanceData();
  const questions: WidgetQuestion[] = [{
    id: '1',
    text: 'Perché bassa conversione?'
  }, {
    id: '2',
    text: 'Quali premi ottimizzare?'
  }];
  return <BentoWidgetCard id="marketplace-pulse" title="Marketplace Premi – Pulse" size="M" lastUpdated="8 min fa" questions={questions} onHide={onHide} onAsk={onAsk} data-id="element-1469">
      <div className="grid grid-cols-2 gap-3 mb-4" data-id="element-1470">
        <div className="bg-blue-50 rounded-lg p-3" data-id="element-1471">
          <Gift className="h-5 w-5 text-blue-600 mb-2" data-id="element-1472" />
          <p className="text-xs text-blue-700" data-id="element-1473">Riscatti</p>
          <p className="text-xl font-bold text-blue-900" data-id="element-1474">
            {data.claims.toLocaleString()}
          </p>
        </div>
        <div className="bg-green-50 rounded-lg p-3" data-id="element-1475">
          <CheckCircle className="h-5 w-5 text-green-600 mb-2" data-id="element-1476" />
          <p className="text-xs text-green-700" data-id="element-1477">Utilizzi</p>
          <p className="text-xl font-bold text-green-900" data-id="element-1478">
            {data.utilizations.toLocaleString()}
          </p>
        </div>
      </div>

      <div className="bg-purple-50 border border-purple-200 rounded-lg p-3 mb-4" data-id="element-1479">
        <p className="text-xs text-purple-700 mb-1" data-id="element-1480">Tasso di Conversione</p>
        <p className="text-2xl font-bold text-purple-900" data-id="element-1481">
          {data.conversionRate}%
        </p>
      </div>

      <div className="space-y-3" data-id="element-1482">
        <div data-id="element-1483">
          <p className="text-xs font-semibold text-gray-900 mb-2" data-id="element-1484">Top Premi</p>
          {data.topRewards.map((reward, index) => <div key={index} className="flex items-center justify-between text-xs mb-1" data-id="element-1485">
              <span className="text-gray-700 flex-1 truncate" data-id="element-1486">
                {reward.name}
              </span>
              <span className="font-medium text-gray-900 ml-2" data-id="element-1487">
                {reward.utilizations}/{reward.claims}
              </span>
            </div>)}
        </div>

        <div data-id="element-1488">
          <p className="text-xs font-semibold text-gray-900 mb-2" data-id="element-1489">
            Premi da Ottimizzare
          </p>
          {data.lowPerforming.map((reward, index) => <div key={index} className="bg-yellow-50 rounded p-2 text-xs mb-1" data-id="element-1490">
              <p className="font-medium text-gray-900" data-id="element-1491">{reward.name}</p>
              <p className="text-yellow-700" data-id="element-1492">{reward.issue}</p>
            </div>)}
        </div>
      </div>
    </BentoWidgetCard>;
};
export default MarketplacePulseWidget;